<template>
  <div class="mb-1" v-if="skin.header_desktop.enabled" id="mainHeader"> 
    <div class="d-flex" :style="skin.header_desktop.nav_bar">
        <div class="text-start">
            <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo" :width="skin.header_desktop.logo_width" alt="">
        </div>
        <div class="d-flex p-0" style="width: 100%;">
            <div class="d-flex" style="width:70%">
                <div v-if="skin.prematch!=null?skin.prematch:true" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <div v-if="skin.front_lobby.enabled" @click="change_view('lobby')" style="cursor:pointer;width:100px;display:table-cell;vertical-align:middle;">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('Lobby') }}</span>
                    </div>
                </div>
                <div v-if="skin.prematch!=null?skin.prematch:true"  @click="change_view('main')" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span style="display:table-cell;vertical-align:middle;" :style="skin.header_desktop.nav_bar_text">{{translate("Deportes")}}</span>
                </div>
                <div v-if="skin.poker" @click="user.token != '' ? change_view('poker') : login()" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;">{{translate("Poker")}}</span>
                </div>
                <div v-if="skin.casinoN" @click="user.token != '' ? change_view('casino') : login()" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;">{{translate("Slots")}}</span>
                </div>
                <div v-if="skin.casino_live" @click="user.token != '' ? change_view('casino_live') : login()" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;">{{translate("Casino Vivo")}}</span>
                </div>
                <div v-if="skin.hipicas" @click="user.token != '' ? change_view('hipicas') : login()" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;">{{translate("Caballos")}}</span>
                </div>
                <div v-if="skin.bingo" @click="user.token != '' ? change_view('bingo') : login()" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;">{{translate("Bingo")}}</span>
                </div>
                <div v-if="skin.crazzywin" @click="user.token != '' ? change_view('crazzyWin') : login()" style="cursor:pointer;display:table;" class="px-2 pe-2 text-center">
                    <span :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;">{{translate("CrazZy Win!")}}</span>
                </div>
            </div>
            <div style="width: 30%;" class="d-flex">
                <div v-if="user.token != ''" class="px-2 pe-2 text-center" style="display:table;width: 65%;">
                    <div v-if="skin.header_desktop.balance" :class="skin.my_account.myaccount_type=='JM'?'':'text-end'" style="cursor:pointer;width:33%;display:table-cell;vertical-align:middle;font-size: 15px;" :style="skin.header_desktop.nav_bar_text">
                        <i @click="showBalanceAction" class="fas fa-coins pr-0 mx-2"></i>
                        <span v-if="showBalance">{{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(balance.saldo) : 0 }}</span>
                    </div>
                    <div v-if="skin.my_account.myaccount_type=='JM' && skin.header_desktop.betLimits" style="cursor:pointer;width:33%;display:table-cell;vertical-align:middle;" :style="skin.header_desktop.nav_bar_text">
                        <span class="dropdown-toggle" href="#" id="navbarDropdown2" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa-solid fa-chart-column"></i>
                        </span>
                        <div class="dropdown-menu p-2" aria-labelledby="navbarDropdown2" style="width: 19rem!important;color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;">
                           <div class="text-center">
                                <span>• Limites máximos de apuestas •</span>
                           </div>
                           <div class="d-flex my-1 mb-1">
                                <span style="width:50%">PragmaticPlay</span>
                                <span style="width:50%;text-align: right;">160.000</span>
                            </div>
                           <div class="d-flex my-1 mb-1">
                                <span style="width:50%">VivoGaming</span>
                                <span style="width:50%;text-align: right;">160.000</span>
                            </div>
                           <div class="d-flex my-1 mb-1">
                                <span style="width:50%">Ezugi</span>
                                <span style="width:50%;text-align: right;">160.000</span>
                            </div>
                           <div class="d-flex my-1 mb-1">
                                <span style="width:50%">Caballos</span>
                                <span style="width:50%;text-align: right;">160.000</span>
                            </div>
                           <div class="d-flex my-1 mb-1">
                                <span style="width:50%">Slots</span>
                                <span style="width:50%;text-align: right;">8.000</span>
                            </div>
                            <span style="font-size: small;">• Toda apuesta que exceda estos limites será rechazada automáticamente.</span>
                        </div>
                    </div>
                    <div v-if="skin.my_account.myaccount_type=='JM' && skin.header_desktop.support" style="cursor:pointer;width:33%;display:table-cell;vertical-align:middle;">
                        <span :style="skin.header_desktop.nav_bar_text+(supportTickets.filter(ticket=>ticket.leido_user_creacion==1).length>0?'color:red;':'')" class="dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa-regular fa-comment-dots"></i>
                        </span>
                        <div class="dropdown-menu p-2" aria-labelledby="navbarDropdown3" style="width: 19rem!important;color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;">
                           <div class="text-center">
                                <span>• Mesa de ayuda •</span>
                           </div>
                           <div class="my-1 mb-1" data-bs-toggle="modal" data-bs-target="#supportJm" @click="openSupportModal('newMessage')">
                                <i class="fa-solid fa-paper-plane mx-2"></i>
                                <span style="">Reportar un problema</span>
                            </div>
                            <div class="my-1 mb-1">
                                <a class="dropdown-item support-item support-item-read" v-for="(ticket, index) in supportTickets" :key="index"
                                href="#" data-id="402987" style="color: rgb(197, 194, 194)!important;background-color: rgba(60,60,60,.9);font-size: 15px;"
                                data-bs-toggle="modal" data-bs-target="#supportJm" @click="openSupportModal(ticket)">
                                    <span :style="ticket.leido_user_creacion==1?'color:red;':''"><i class="far fa-comment me-2" aria-hidden="true"></i></span>
                                    <span>Ticket #{{ ticket.id }}</span>
                                    <span class="float-end"> {{ countDays(ticket.fecha) }}d <i class="far fa-clock" aria-hidden="true"></i></span>
                                </a>
                            </div>
                            <div class="text-center">
                                <span>• Notificaciones •</span>
                           </div>
                        </div>
                    </div>
                </div>
                 <div v-if="user.token == '' && skin.register" @click="register" style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.register_btn" class="py-2 px-2 pe-2 text-center">
                    <span style="display:table-cell;vertical-align:middle;">{{translate("sign_in")}}</span>
                </div>
                <div v-if="user.token == '' && skin.login" @click="login" style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.login_btn" class="py-2 px-2 pe-2 text-end">
                    <span style="display:table-cell;vertical-align:middle;"><i class="fas fa-sign-in-alt"></i> {{translate("log_in")}}</span>
                </div>
                <div v-if="user.token != ''" style="cursor:pointer;width:35%" class="py-1 me-2 pb-1 px-2 pe-2 text-center nav-item dropdown">
                    <a v-if="skin.my_account.myaccount_type=='JM'" :style="skin.header_desktop.nav_bar_text" class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="far fa-user mx-2"></i>{{ user.user_data.data ? user.user_data.data.username : '' }}
                    </a>
                    <a v-else :style="skin.header_desktop.nav_bar_text" class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="far fa-user mx-2"></i>{{ user.user_data.data ? user.user_data.data.name : '' }}
                    </a>
                    <div style="color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;" class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <div v-if="skin.my_account.myaccount_type=='JM' && skin.header_desktop.userMenu.changePassword" id="changePasswordBtn" class="px-2 pe-2" data-bs-toggle="modal" data-bs-target="#changePasswordJm">
                            <span>Cambiar contraseña</span>
                        </div>
                        <div v-if="skin.my_account.myaccount_type=='JM'">
                            <div v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()" class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccountJm"> <span>Historial de saldo</span> </div>
                        </div>
                        <div v-else class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccount"> <span>Historial de saldo</span> </div>
                        <div v-if="skin.my_account.myaccount_type=='JM' && skin.header_desktop.userMenu.loginHistory" @click="getIngresos()" class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#historial_ingresos"> <span>Historial de ingresos</span> </div>
                        <div v-if="skin.header_desktop.userMenu.sportsRules" @click="terms" class="px-2 pe-2 p-1"> <span>{{ translate("terms_and_conditions") }}</span> </div>
                        <!-- <a @click="change_view('results')" class="px-2 pe-2 p-1" :style="skin.header_desktop.servicios_text2"> <span>{{translate("results")}}</span> </a> -->
                        <div v-if="skin.logout" @click="logout" class="px-2 pe-2 p-1"> <span>Cerrar sesión</span> </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <my-account
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
        <myAccountJM
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
        <!-- Button trigger modal -->
        <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login" style="display:none;"></button>
        <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle" style="display:none;"></button>
        <login
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
        <changePassword
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
        <historialIngresos
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
        <register
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
    </div>
  </div>
</template>

<script>
import myAccountJM from "./my_accountJM.vue";
import myAccount from "./my_account.vue";
import login from "./login.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";
import historialIngresos from "./historialIngresos.vue";
import axios from "axios";
export default {
    name:"mainHeader",
    props:['skin','language','translation'],
    data(){
        return {
            showBalance:false,
            userDataLoaded:false,
            balance:{
                saldo:0,
                conversion:0,
                view:"SALDO",
                switch:1
            },
            newMessage:false,
            supportTickets:[]
        }
    },
    components:{
        myAccountJM,
        myAccount,
        login,
        register,
        languageSelector,
        changePassword,
        historialIngresos
    },
    methods:{
        showBalanceAction(){
            if(!this.showBalance){
                this.$store.dispatch('getUserData',{
                    token:this.user.token,
                    site_id:this.user.site_id,
                    site:this.user.site,
                    prefix:this.user.prefix,
                    source:"main"
                });
                this.showBalance = true
            }
            else{
                this.showBalance = false
            }
        },
        openSupportModal(type){
            this.$root.$emit('openSupportModal',type);
            if(type.id){
                this.readTicket(type)
            }
        },
        getMovements(){
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos(){
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val,fiat){
            let tasa = 1;
            if(this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false){
                tasa = this.currency.rate;
            }
            return (fiat!='BETC'?(fiat=='USDT'?val*tasa:val*tasa*this.user.user_data.data.tasa):val).toFixed(2);
        },
        terms(){
            let url = "";
            let lang = this.$props.language=='es'?'spa':(this.$props.language=='en'?'eng':(this.$props.language=='pt'?'pt-br':'spa'));
            if(this.user.prefix=="external"){
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+this.user.site.toUpperCase()+"&link="+this.user.site;
            }
            else{
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1]+'.'+domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+domain_name1+"&link="+domain_name2;
            }
            
            window.open(url, '_blank').focus();
        },
        login(){
            document.getElementById('login_btn').click();
        },
        register(){
            document.getElementById('register_btn').click();
        },
        logout(){
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account(){
            window.parent.postMessage(
            {
                action: 'openSlider',
                tab: 'recentBets'
            },
            '*'
            );
        },
        change_view(view){
            if(view == "casino_live"){
                window.postMessage({view: 'casino_live'},'*');
            }
            else if(view == "hipicas"){
                window.postMessage({view: 'hipicas'},'*');
            }
            else{
                this.$store.dispatch('setLobbyView',view);
                this.$store.dispatch('setView',view);
            }
        },
        translate(text) {
            if(text){
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else{
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        changeBalanceView(){
            let balance = 0;
            let disponible = 0
            if(this.config.SkinConfig.main.newbonus ? this.$store.getters['getConfig'].SkinConfig.main.newbonus : false){
                balance = this.user.user_data.data.available_balance + this.user.user_data.data.bonus + this.user.user_data.data.frozen;
                disponible = this.user.user_data.data.available_balance;
            }
            else{
                balance = this.user.user_data.data.balance;
                disponible = this.user.user_data.data.bonus_balance;
            }
            let tasa = 1;
            if(this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false){
                tasa = this.currency.rate;
            }
            if(this.balance.switch == 0){
                this.balance.saldo = balance;
                this.balance.conversion = (this.currency.fiat!='BETC'?(this.currency.fiat=='USDT'?balance*tasa:balance*tasa*this.user.user_data.data.tasa):balance).toFixed(2);
                this.balance.view = "SALDO";
                this.balance.switch = 1;
            }
            else{
                this.balance.saldo = disponible;
                this.balance.conversion = (this.currency.fiat!='BETC'?(this.currency.fiat=='USDT'?balance*tasa:balance*tasa*this.user.user_data.data.tasa):balance).toFixed(2);
                this.balance.view = "DISPONIBLE";
                this.balance.switch = 0;
            }
        },
        async readTicket(ticket){
            if(ticket.leido_user_creacion != 0){
                await axios.post("https://reportes." + this.user.domain.split("admin.")[1] +"/leido_soporte", {
                    "login_Id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                    "ticket": ticket.id
                })
                this.getSupportTickets();
            }
        },
        async getSupportTickets(){
            try {
                let tickets = await axios.post("https://reportes." + this.user.domain.split("admin.")[1] +"/estado_soporte", {
                    "login_Id": this.user.user_data.data.user_id ?? this.user.user_data.data.id
                })
                if(tickets.data){
                    this.supportTickets = tickets.data;
                }
            } catch (error) {
                // integration
            }
        },
        countDays(init){
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        }
    },
    computed:{
         user(){
            let config = this.$store.getters['getConfig'];
            let data = this.$store.getters['getUserData'];
            if(data.user_data.data){
                this.balance.saldo = config.SkinConfig.main.newbonus ? data.user_data.data.available_balance + data.user_data.data.bonus + data.user_data.data.frozen: data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
         },
         currency(){
            return this.$store.getters['getCurrency'];
         },
         header_productsQty(){
            let products = [this.$props.skin.poker,this.$props.skin.prematch,this.$props.skin.casinoN,this.$props.skin.casino_live,this.$props.skin.hipicas,this.$props.skin.login,this.$props.skin.logout];
            return products.filter(x => x==true).length + 1;
        },
        config(){
            return this.$store.getters['getConfig'];
        },
     },
     mounted(){
        if(this.skin.header_desktop.enabled){
            this.$store.dispatch("setHeaderHeight",document.getElementById("mainHeader").offsetHeight+5);
        }
        this.$root.$on('loadSupportModal', () => {
            this.getSupportTickets();
        });
     },
     watch:{
        userDataLoaded(newVal,oldVal){
            if(newVal!=oldVal && newVal){
                this.getSupportTickets();
            }
        },
        showBalance(newVal,oldVal){
            if(newVal){
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
     }
}
</script>

<style scoped>
    .center_div{
        width: 90%; /* Can be in percentage also. */
        height: auto;
        margin: 0 auto;
        padding: 0px;
        position: relative;
    }
</style>